import i18n from 'i18next';

/**
 * Get the translated subject for registration confirmation email
 * @returns The translated subject
 */
export const getRegistrationEmailSubject = (): string => {
  return i18n.t('email.registration.subject');
};

/**
 * Get the translated subject for registration modification email
 * @returns The translated subject
 */
export const getModificationEmailSubject = (): string => {
  return i18n.t('email.modification.subject');
};

/**
 * Get the translated subject for registration cancellation email
 * @returns The translated subject
 */
export const getCancellationEmailSubject = (): string => {
  return i18n.t('email.cancellation.subject');
};

/**
 * Get the translated success message for create operation
 * @returns The translated success message
 */
export const getCreateSuccessMessage = (): string => {
  return i18n.t('queries.establishment.createSuccess');
};

/**
 * Get the translated success message for update operation
 * @returns The translated success message
 */
export const getUpdateSuccessMessage = (): string => {
  return i18n.t('queries.establishment.updateSuccess');
};

/**
 * Get the translated success message for delete operation
 * @returns The translated success message
 */
export const getDeleteSuccessMessage = (): string => {
  return i18n.t('queries.establishment.deleteSuccess');
}; 